import React, { useEffect, useState, useContext } from 'react'
import moment from 'moment'
import {
   Avatar,
   Box,
   Button,
   Card,
   CardActions,
   CardContent,
   Divider,
   Typography
} from '@material-ui/core'
import { putPublicAPI } from '../../api'
import { toast } from 'react-toastify'
// contexts
import { ToastContext } from '../../contexts/Toast'

const AccountProfile = props => {
   // const [user, setUser] = useState({
   //    avatar: '/static/images/avatars/avatar_6.png',
   //    city: 'Los Angeles',
   //    country: 'USA',
   //    email: localStorage.
   // })
   

   const user = {
      avatar: localStorage.user_pic,
      city: 'Los Angeles',
      country: 'USA',
      email: localStorage.user_email,
      name: localStorage.user_name,
      company: localStorage.user_company
   }
   const { setToasts } = useContext(ToastContext)
   const [selectedFiles, setSelectedFiles] = useState(null)
   const onFilesChange = event => setSelectedFiles(event.target.files)
   // const [fileUploaded, setFileUploaded] = useState(false)
   const imageUploader = React.useRef(null)

   const toBase64 = file =>
      new Promise((resolve, reject) => {
         const reader = new FileReader()
         reader.readAsDataURL(file)
         reader.onload = () => resolve(reader.result)
         reader.onerror = error => reject(error)
      })

   useEffect(() => {
      imageUploader.current.click()
   }, [selectedFiles])

   const onFilesUpload = async () => {
      // {onFilesChange}
      if (selectedFiles) {
         let filesData = []

         for await (let file of selectedFiles) {
            filesData.push({
               name: file.name.trim(),
               data: await toBase64(file)
            })
         }
         toast.info('Uploading', {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: false
         })
         try {
            await Promise.all(
               filesData.map(async fileData => {
                  // console.log(fileData)

                  let updated = await putPublicAPI('/upload-pictures', {
                     fileData,
                     id: localStorage.user_id
                  })

                  if (updated?.success) {
                     const { picture } = updated.data
                     localStorage.setItem('user_pic', picture)
                  } else setToasts({ type: 'error', messages: updated?.errors })
               })
            )

            setSelectedFiles(null)
            toast.dismiss()
            setToasts({
               type: 'success',
               messages: [{ msg: 'Pictures uploaded' }]
            })
            // setFileUploaded(false)

            setTimeout(() => {
               window.location.reload()
            }, 1000)
         } catch (err) {
            console.log(err)
            setToasts({
               type: 'error',
               messages: [{ msg: 'Some error occurred' }]
            })
         }
      }
   }

   useEffect(() => {}, [])

   return (
      <Card {...props}>
         <CardContent>
            <Box
               sx={{
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'column'
               }}
            >
               <Avatar
                  src={user.avatar}
                  sx={{
                     height: 100,
                     width: 100
                  }}
               />
               <Typography color='textPrimary' gutterBottom variant='h3'>
                  {user.name}
               </Typography>
               {localStorage.user_company !== 'undefined' ? (
                  <Typography color='textSecondary' variant='body1'>
                     {localStorage.user_company}
                  </Typography>
               ) : (
                  <Typography color='textSecondary' variant='body1'>
                     {user.email}
                  </Typography>
               )}
               <Typography color='textSecondary' variant='body1'>
                  {`${moment().format('hh:mm A')}`}
               </Typography>
            </Box>
         </CardContent>
         <Divider />
         <CardActions style={{ justifyContent: 'center' }}>
            <label
               style={{
                  padding: '6px 8px',

                  textTransform: 'uppercase',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#d22f25',
                  alignSelf: 'center',

                  fontFamily: '"Roboto","Helvetica","Arial",sans-serif'
               }}
               htmlFor='files-upload'
            >
               <input
                  type='file'
                  multiple={true}
                  style={{ display: 'none' }}
                  id='files-upload'
                  onChange={onFilesChange}
                  label='import'
               />
               Upload picture
            </label>
            <Button
               ref={imageUploader}
               style={{ display: 'none' }}
               onClick={onFilesUpload}
               color='primary'
               fullWidth
               variant='text'
            >
               Upload picture
            </Button>
         </CardActions>
      </Card>
   )
}

export default AccountProfile
